import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums";
import {
  createSelectedItemsSlice,
  type SelectedItemsState,
} from "features/Application/slices/createSelectedItemsSlice";
import { type ScormGroup } from "../../types/models";

export interface GroupsState extends SelectedItemsState<ScormGroup> {}

const initialState: GroupsState = {
  items: [],
  itemsCount: 0,
  selectedIds: [],
  isLoading: false,
  error: undefined,
  selectedItems: [],
};

const groupsSlice = createSelectedItemsSlice(
  { namespace: ReducerNamespaceTypes.Library, entity: ReducerEntityPrefixTypes.Scorm, name: "groups" },
  initialState,
);

export const { fetchBegin, fetchSuccess, fetchFailure, selectedItemsChanged, resetSelectedItems } = groupsSlice.actions;

export default groupsSlice.reducer;
